import React, { useState } from 'react';
import { Shield, Users, History, Upload, ClipboardCheck } from 'lucide-react';
import LoginLogsTab from './AdminPage/LoginLogsTab';
import Karat307ImportTab from './AdminPage/Karat307ImportTab';

const AdminPage = () => {
    const [activeTab, setActiveTab] = useState('users');

    return (
        <div>
            <h2 className="text-xl sm:text-2xl font-bold text-white mb-4 sm:mb-6 flex items-center gap-2">
                <Shield className="w-6 h-6 text-blue-400" />
                Администрирование
            </h2>

            {/* Вкладки */}
            <div className="flex gap-2 mb-6 border-b border-slate-700 overflow-x-auto">
                <button
                    onClick={() => setActiveTab('users')}
                    className={`px-4 py-2 font-medium transition flex items-center gap-2 whitespace-nowrap ${activeTab === 'users'
                        ? 'text-blue-400 border-b-2 border-blue-400'
                        : 'text-slate-400 hover:text-white'
                        }`}
                >
                    <Users className="w-4 h-4" />
                    Пользователи
                </button>
                <button
                    onClick={() => setActiveTab('logs')}
                    className={`px-4 py-2 font-medium transition flex items-center gap-2 whitespace-nowrap ${activeTab === 'logs'
                        ? 'text-blue-400 border-b-2 border-blue-400'
                        : 'text-slate-400 hover:text-white'
                        }`}
                >
                    <History className="w-4 h-4" />
                    Лог входов
                </button>
                <button
                    onClick={() => setActiveTab('karat307import')}
                    className={`px-4 py-2 font-medium transition flex items-center gap-2 whitespace-nowrap ${activeTab === 'karat307import'
                        ? 'text-blue-400 border-b-2 border-blue-400'
                        : 'text-slate-400 hover:text-white'
                        }`}
                >
                    <Upload className="w-4 h-4" />
                    Загрузка архивов Карат-307
                </button>
            </div>

            {/* Содержимое вкладок */}
            {activeTab === 'users' && (
                <div className="bg-slate-800 rounded-xl p-4 sm:p-6 border border-slate-700">
                    <p className="text-slate-400 text-sm sm:text-base">
                        Управление пользователями и правами доступа
                    </p>
                    <p className="text-slate-500 text-sm mt-2">
                        (Функционал в разработке)
                    </p>
                </div>
            )}

            {activeTab === 'logs' && <LoginLogsTab />}

            {activeTab === 'karat307import' && <Karat307ImportTab />}
        </div>
    );
};

export default AdminPage;